import { render, staticRenderFns } from "./AthleteChip.vue?vue&type=template&id=3a51864f&scoped=true&"
import script from "./AthleteChip.vue?vue&type=script&lang=ts&"
export * from "./AthleteChip.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteChip.vue?vue&type=style&index=0&id=3a51864f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51864f",
  null
  
)

export default component.exports